import type {
  ResolutionSetup,
  ResolutionSetupChangeParams,
  ResolutionType
} from '@library/types/resolutions/resolutionDetails';
import {
  defaultResolutionSetup,
  resolutionInputTypeMapping
} from '@bo-constants/resolutions/resolutionDetails';
import { useCallback, useState } from 'react';

export const useCreateResolution = () => {
  const [resolutionSetup, setResolutionSetup] = useState<ResolutionSetup>(
    defaultResolutionSetup
  );

  const handleChangeResolutionSetup = useCallback(
    ({ key, value }: ResolutionSetupChangeParams) => {
      setResolutionSetup((prevSetup) => {
        if (key === 'resolutionType' && prevSetup?.resolutionInputType) {
          const newResolutionType = value as ResolutionType;

          const validResolutionInputTypes = newResolutionType
            ? resolutionInputTypeMapping[newResolutionType]
            : [];

          return {
            [key]: value,
            resolutionInputType: !validResolutionInputTypes.includes(
              prevSetup.resolutionInputType
            )
              ? validResolutionInputTypes[0]
              : prevSetup.resolutionInputType
          } as ResolutionSetup;
        }

        return {
          ...prevSetup,
          [key]: value
        };
      });
    },
    []
  );

  return {
    onChangeResolutionSetup: handleChangeResolutionSetup,
    resolutionSetup
  };
};
